<template>
  <div class="page">
    <div class="nav-wrapper">
      <Navbar />
    </div>
    <div class="page-wrapper">
      <div class="filter-wrapper">
        <div class="estimation-phrase">
          <p>{{ $t('display_number_estimations') }} {{ totalEstimations }}</p>
        </div>
        <div class="filter-container filter-container--auto">
          <SearchInput @update-search-value="filterEstimations" />
          <Sort :options="sortOptions" @action="filterEstimations" />
        </div>
      </div>
      <div class="list-container">
        <List :headers="headers">
          <tr v-for="(item, i) in estimations" :key="i" class="list__line">
            <td>{{ item.client.firstName }} {{ item.client.lastName }}</td>
            <td>{{ prettyFullDate(item.createdAt) }}</td>
            <td>{{ $t(`estimation.${item.rejectReason}`) }}</td>
            <td>{{ prettyFullDate(item.rejectedAt) }}</td>
          </tr>
        </List>
      </div>
      <InfiniteScroll
        v-if="estimations.length < totalEstimations"
        :items-per-page="30"
        @paginate="paginateEstimations"
      />
    </div>
  </div>
</template>

<script>
import Navbar from '../../components/Navbar';
import List from '../../components/List';
import { SearchInput, Sort, InfiniteScroll } from '../../components/filters';
import { formatDate, formatNumber, EstimationComponent } from '../../mixins';
import { infiniteLoading } from '../../lib/customEvents';

export default {
  components: { Navbar, List, SearchInput, Sort, InfiniteScroll },

  mixins: [formatDate, formatNumber, EstimationComponent],

  data() {
    return {
      headers: ['fullname', 'reception-date', 'reason.title', 'refusal-date'],
      sortOptions: [
        {
          title: 'filter.sort.newer',
          sortedElement: 'order[createdAt]',
          order: 'desc',
        },
        {
          title: 'filter.sort.older',
          sortedElement: 'order[createdAt]',
          order: 'asc',
        },
      ],
    };
  },

  async created() {
    const rejectedEstimations = await this.fetchEstimations({
      status: 'rejected',
      itemsPerPage: 30,
    });

    if (!rejectedEstimations || !rejectedEstimations['hydra:member']) return;

    this.estimations = rejectedEstimations['hydra:member'];

    if (!rejectedEstimations['hydra:totalItems']) return;

    this.totalEstimations = rejectedEstimations['hydra:totalItems'];
  },
};
</script>
